import React from 'react'
import { Redirect } from 'react-router-dom'
import store from '../store'
import AjaxLoader from '../components/AjaxLoader'
import globals from '../globals'

const LoginHOC = (WrappedComponent) => {
    return class extends React.Component {
        constructor (props) {
            super(props)

            this.state = {
                redirect: false,
                success: false,
                redirectTo: '/'
            }
        }

        handleSuccess (response) {
            this.setState({ success: true })

            const successPromise = new Promise((resolve, reject) => {
			    this.props.logout()
                this.props.setAccessToken(response.data.access_token, response.data.persistLogin)

                if (store.getState().auth.isLoggedIn) {
                    resolve()
                }
            })

            successPromise.then(() => {
                globals.setSentryUser()
                globals.setHotjarUser()
                this.redirect()
            })
        }

        redirect () {
            const redirectTo = store.getState().auth.redirectTo

            this.setState({
                redirectTo: redirectTo || '/'
            }, () => {
                this.setState({ redirect: true })
            })
        }

        render () {
            if (!this.state.redirect && this.state.success) {
                return <AjaxLoader />
            }

            return this.state.redirect ? <Redirect to={this.state.redirectTo} /> : <WrappedComponent handleSuccess={this.handleSuccess.bind(this)} {...this.props} />
        }
    }
}

export default LoginHOC



// WEBPACK FOOTER //
// ./resources/js/auth/LoginHOC.js